module.exports = __webpack_public_path__ + "assets/img/11_666_big.71dd132a.jpg";